/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import registerActions from 'loraactions/register';
import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const propTypes = {
  loadCaptcha: React.PropTypes.func.isRequired,
  captchaState: React.PropTypes.object.isRequired,
  intl: React.PropTypes.object.isRequired,
};

class Captcha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaState: props.captchaState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'register.captcha');
  }

  componentWillMount() {
    const { loadCaptcha } = this.props;
    loadCaptcha();
  }

  componentWillReceiveProps(nextProps) {
    const { captchaState } = nextProps;
    if (captchaState !== this.props.captchaState) {
      this.setState({ captchaState });
    }
  }

  render() {
    const { loadCaptcha } = this.props;
    const { captchaState } = this.state;
    const { data: { src } = {}, status = '' } = captchaState;

    return (
      <div className={styles.captcha}>
        <ShowIf if={status === 'pending'}>
          <i className="fa fa-spinner fa-spin" />
        </ShowIf>
        <ShowIf if={status === 'success'}>
          <Link onClick={loadCaptcha}>
            <img alt="" src={src} />
          </Link>
        </ShowIf>
        <ShowIf if={status === 'failure'}>
          <Link onClick={loadCaptcha}>
            <i className="fa fa-exclamation-triangle" />{' '}
            {this.intlMsg.msg('loadfailed')}
          </Link>
        </ShowIf>
      </div>
    );
  }
}

Captcha.propTypes = propTypes;

const mapStateToProps = state => ({
  captchaState: state.register.captcha,
});
const mapDispatchToProps = {
  loadCaptcha: registerActions.captcha,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Captcha));




// WEBPACK FOOTER //
// ./src/containers/Register/coms/Captcha/index.jsx